import { sendRequestJson } from '@/utils'
import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

class MenuRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async getAvailableMenus() {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/menu/get'), // absolute or relative
			method: 'POST', // keep POST until the backend changes
			body: null, // explicit: no content
			token: null, // skip Authorization header (like “false” before)
			expect: 'json', // default, but explicit is clearer
			throwOnNonOk: true
		})

		return data

		/*const url = this.urlBase + "/world/api/menu/get"
		try {
			return await sendRequestJson({data:{}, url, method:"POST"});
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los productos del menu.");
		}*/
	}

	async getAvailableMenuProducts() {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/product/menu/get'), // absolute or relative
			method: 'POST', // keep POST until the backend changes
			body: null, // explicit: no content
			token: null, // skip Authorization header (like “false” before)
			expect: 'json', // default, but explicit is clearer
			throwOnNonOk: true
		})

		return data
		/*const url = this.urlBase + "/world/api/product/menu/get"
		try {
			return await sendRequestJson({data:{}, url, method:"POST"});
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los productos que son menú.");
		}*/
	}

	async updateMenuProduct(menuProduct) {
		const url = this.urlBase + '/world/api/product/menu/update'
		try {
			console.log('Si todo va bien actualizamos menuProduct ', menuProduct)
			return await sendRequestJson({ data: { menuProduct }, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando el producto menú.')
		}
	}

	async sendReview(data) {
		const url = this.urlBase + '/world/api/review/create'
		try {
			console.log('Enviamos la review ', data)
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal creando la review.')
		}
	}

	async addTextToReview(data) {
		const url = this.urlBase + '/world/api/review/addtext'
		try {
			console.log('Enviamos el texto para la review ', data)
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando la review.')
		}
	}

	registerClickReview(data) {
		const url = this.urlBase + '/world/api/review/update'
		try {
			console.log('Enviamos el click para la review ', data)
			sendRequestJson({ data, url, method: 'POST' }).then((result) => console.log(result))
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando la review.')
		}
	}
}

export const menuRepository = new MenuRepository()
